import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { IconClose } from './talkAppleIcons';
import './comments-sheet.css';

export default function CommentsSheet({ children, onClose }) {
  const sheetRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const sheet = sheetRef.current;
    sheet.querySelector('button')?.focus();
    const onKeyDown = event => {
      if (event.key === 'Escape') { event.preventDefault(); closeRef.current(); }
      if (event.key !== 'Tab') return;
      const controls = [...sheet.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], summary')].filter(el => !el.closest('details:not([open])') || el.tagName === 'SUMMARY');
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    sheet.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = overflow;
      sheet.removeEventListener('keydown', onKeyDown);
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return createPortal(
    <div className="jt-comments-overlay" onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="jt-comments-sheet" ref={sheetRef} role="dialog" aria-modal="true" aria-label="コメント">
        <div className="jt-comments-handle" aria-hidden="true" />
        <header className="jt-comments-sheet-header">
          <h2>コメント</h2>
          <button type="button" onClick={onClose} aria-label="コメントを閉じる"><IconClose size={22} /></button>
        </header>
        {children}
      </section>
    </div>, document.body
  );
}
